import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import LanguageSelect from "@/components/LanguageSelect.vue";
import { useValidateProps } from "@/composables/fields";
import { dbEnums } from "@/types/enums/dbEnums";
import { DraftCompanyDto } from "@api/draft-company-dto";
import { PropType, computed } from "vue";
import { CompanyFieldCategoryMap } from "..";
import Field from "../../Field.vue";
import FormFields from "../../FormFields.vue";
import FormSection from "../../FormSection.vue";
import FormSectionHeader from "../../FormSectionHeader.vue";
import { isMobileReactive } from "@/helpers";


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyFormContactPersonFields',
  props: {
	fieldsMap: {
		type: Object as PropType<CompanyFieldCategoryMap>,
		required: true,
	},
	modelValue: {
		type: Object as PropType<DraftCompanyDto>,
		required: true,
	},
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const fields = dbEnums.CompanyFields;

const props = __props;

const emit = __emit;

const formDataComputed = computed({
	get() {
		return props.modelValue;
	},
	set(v) {
		emit("update:modelValue", v);
	},
});

const validateProps = useValidateProps();

return (_ctx: any,_cache: any) => {
  const _component_HakoInput = _resolveComponent("HakoInput")!
  const _component_HakoDatePicker = _resolveComponent("HakoDatePicker")!
  const _component_HakoTeleInput = _resolveComponent("HakoTeleInput")!

  return (_openBlock(), _createBlock(FormSection, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(FormSectionHeader, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("companyForm.sectionContactPerson.header")), 1)
            ]),
            _: 1
          })
        ]),
        (__props.fieldsMap.DraftCompanyContactPersonInfo)
          ? (_openBlock(), _createBlock(FormFields, {
              key: 0,
              fields: __props.fieldsMap.DraftCompanyContactPersonInfo.fields
            }, {
              [_unref(fields).DraftCompanyContactPersonFirstName]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftCompanyData.contactPersonFirstName"
                }, {
                  default: _withCtx(({ elementId, isInvalid, propertyPaths }) => [
                    _createVNode(_component_HakoInput, {
                      modelValue: formDataComputed.value.contactPersonFirstName,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formDataComputed.value.contactPersonFirstName) = $event)),
                      id: elementId,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                      style: {"max-width":"500px"}
                    }, null, 8, ["modelValue", "id", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).DraftCompanyContactPersonLastName]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftCompanyData.contactPersonLastName"
                }, {
                  default: _withCtx(({ elementId, isInvalid, propertyPaths }) => [
                    _createVNode(_component_HakoInput, {
                      modelValue: formDataComputed.value.contactPersonLastName,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formDataComputed.value.contactPersonLastName) = $event)),
                      id: elementId,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                      style: {"max-width":"500px"}
                    }, null, 8, ["modelValue", "id", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).DraftCompanyContactPersonTitle]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftCompanyData.contactPersonTitle"
                }, {
                  default: _withCtx(({ elementId }) => [
                    _createVNode(_component_HakoInput, {
                      modelValue: formDataComputed.value.contactPersonTitle,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formDataComputed.value.contactPersonTitle) = $event)),
                      id: elementId,
                      style: {"max-width":"500px"}
                    }, null, 8, ["modelValue", "id"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).DraftCompanyContactPersonDateOfBirth]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftCompanyData.contactPersonDateOfBirth"
                }, {
                  default: _withCtx(({ elementId }) => [
                    _createVNode(_component_HakoDatePicker, {
                      modelValue: formDataComputed.value.contactPersonDateOfBirth,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formDataComputed.value.contactPersonDateOfBirth) = $event)),
                      allowEmpty: true,
                      id: elementId,
                      style: {"max-width":"250px"},
                      placeholder: _ctx.$t('generic.datePlaceholder'),
                      forceUtcMidnight: ""
                    }, null, 8, ["modelValue", "id", "placeholder"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).DraftCompanyContactPersonEmail]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftCompanyData.contactPersonEmail"
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createVNode(_component_HakoInput, {
                      modelValue: formDataComputed.value.contactPersonEmail,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formDataComputed.value.contactPersonEmail) = $event)),
                      id: elementId,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                      style: {"max-width":"500px"}
                    }, null, 8, ["modelValue", "id", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).DraftCompanyContactPersonPhoneNumber]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftCompanyData.contactPersonPhoneNumber"
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createVNode(_component_HakoTeleInput, {
                      modelValue: formDataComputed.value.contactPersonPhoneNumber,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formDataComputed.value.contactPersonPhoneNumber) = $event)),
                      id: elementId,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                      style: {"max-width":"250px"}
                    }, null, 8, ["modelValue", "id", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).DraftCompanyContactPersonLanguage]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftCompanyData.contactPersonLanguageId"
                }, {
                  default: _withCtx(({ elementId }) => [
                    _createVNode(LanguageSelect, {
                      valueSingle: formDataComputed.value.contactPersonLanguage,
                      "onUpdate:valueSingle": _cache[6] || (_cache[6] = ($event: any) => ((formDataComputed.value.contactPersonLanguage) = $event)),
                      valueSingleId: formDataComputed.value.contactPersonLanguageId,
                      "onUpdate:valueSingleId": _cache[7] || (_cache[7] = ($event: any) => ((formDataComputed.value.contactPersonLanguageId) = $event)),
                      communicationRole: _unref(dbEnums).PersonUserRoleIds.Elinkeino,
                      id: elementId,
                      style: {"max-width":"250px"}
                    }, null, 8, ["valueSingle", "valueSingleId", "communicationRole", "id"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              _: 2
            }, 1032, ["fields"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})